<div>

    <div>
        <h2>Training</h2>
    </div>

    <nz-collapse>
      <ng-container *ngFor="let panel of panels">
        <nz-collapse-panel [nzHeader]="panel.name" [nzActive]="panel.active" [nzDisabled]="panel.disabled">
          <div style="display: flex; align-items: center; justify-content: space-between;" *ngFor="let t of panel.training">
            <p style="margin:0;">{{t.name}}</p>
            <button nz-button nzType="primary" nzShape="circle" (click)="openFile(t)">
              <span nz-icon nzType="eye" nzTheme="fill"></span>
            </button>
          </div>
        </nz-collapse-panel>
      </ng-container>
    </nz-collapse>
</div>